import { render, staticRenderFns } from "./DoNotCall.vue?vue&type=template&id=b7ef069c&"
import script from "./DoNotCall.vue?vue&type=script&lang=js&"
export * from "./DoNotCall.vue?vue&type=script&lang=js&"
import style0 from "./DoNotCall.vue?vue&type=style&index=0&id=b7ef069c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports